import styles from './styles.module.scss'

const Spinner = ({ active, color = 'gray', size = '60px', background = 'rgba(0, 0, 0, 0.3)', position = 'absolute' }) => {
    return (
        <div style={{ background, position }} className={`${styles['spinner']} ${styles[active]}${styles[size]}`}>
            <div style={{
                width: size,
                height: size,
            }} className={`${styles['spinner-item']}  ${styles[color]} `}></div>
        </div>
    )
}

export default Spinner;